import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";

import { EMPTY, Observable, of, switchMap } from "rxjs";
import { select, Store } from "@ngrx/store";
import { catchError, take } from "rxjs/operators";

import { selectCustomerState } from "../store/customer.selectors";
import { AddressesLoaded } from "../store/customer.actions";
import { CustomerState } from "../store/customer.reducer";
import { SapAddress } from "libs/sap/src/lib/models/sap.model";
import { AppState } from "libs/tm-common/src/lib/store/reducers/reducers";
import { NotificationService } from "libs/tm-common/src/lib/services/notification.service";
import { SapService } from "libs/sap/src/lib/services/sap.service";

@Injectable()
export class CustomerAddressesResolver {
	constructor(
		private notificationService: NotificationService,
		private sapService: SapService,
		private store: Store<AppState>
	) {}

	resolve(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): Observable<{ billingAddresses: SapAddress[]; shippingAddresses: SapAddress[] }> {
		return this.store.pipe(
			select(selectCustomerState),
			take(1),
			switchMap((state: CustomerState) => {
				//check if addresses are already available in the redux store
				if (state.shippingAddresses.length > 0 && state.billingAddresses.length > 0) {
					return of({
						billingAddresses: state.billingAddresses,
						shippingAddresses: state.shippingAddresses
					});
				}
				//addresses need to be fetched from SAP and saved in redux store
				return this.sapService.getCustomerAddresses().pipe(
					take(1),
					switchMap(
						(addresses: {
							billingAddresses: SapAddress[];
							shippingAddresses: SapAddress[];
						}) => {
							this.store.dispatch(new AddressesLoaded(addresses));
							return of({
								billingAddresses: addresses.billingAddresses,
								shippingAddresses: addresses.shippingAddresses
							});
						}
					),
					catchError(() => {
						this.notificationService.showErrorMessage(
							"ResolveOrderDataError",
							"Error loading customer addresses",
							5000
						);
						return EMPTY;
					})
				);
			})
		);
	}
}
